export default __webpack_public_path__ + "static/media/13.6806e060.png";